export default {"theme":{"dark":false,"themes":{"dark":{"primary":undefined,"accent":undefined,"secondary":undefined,"info":undefined,"warning":undefined,"error":undefined,"success":undefined}}}}
